/* NOVY ICE — extras: predictive search, email popup, honest countdown, recently viewed, UGC video, recommendations. */
(() => {
  const theme = window.theme || {};
  const U = window.NovyUtil || { $: (s, r = document) => r.querySelector(s), $$: (s, r = document) => Array.from(r.querySelectorAll(s)), announce: () => {}, trapFocus: () => {} };
  const { $, $$ } = U;
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  };

  /* ---------- Predictive search ---------- */
  const lock = (o) => (U.lockScroll ? U.lockScroll(o) : (document.body.style.overflow = 'hidden'));
  const unlock = (o) => (U.unlockScroll ? U.unlockScroll(o) : (document.body.style.overflow = ''));
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this._bound) { this.listen(); return; }
      this.input = $('input[type="search"]', this);
      this.results = $('[data-search-results]', this);
      this.defaults = $('[data-search-default]', this);
      this.status = $('[data-search-status]', this);
      if (!this.input || !this.results) return;
      this._bound = true;
      this.active = -1;
      this.onDocClick = (e) => {
        if (!this.isConnected) return;
        const opener = e.target.closest('[data-search-open]');
        if (opener) { e.preventDefault(); this.open(opener); }
      };
      this.onDocKey = (e) => {
        if (!this.isConnected || e.key !== '/' || !this.hidden || e.ctrlKey || e.metaKey || e.altKey) return;
        const a = document.activeElement;
        if (a && (['INPUT', 'TEXTAREA', 'SELECT'].includes(a.tagName) || a.isContentEditable)) return;
        if (document.querySelector('.drawer.is-open, dialog[open], .popup:not([hidden])')) return;
        e.preventDefault(); this.open();
      };
      this.addEventListener('click', (e) => { if (e.target === this || e.target.closest('[data-search-close]')) this.close(); });
      this.addEventListener('keydown', (e) => this.onKey(e));
      this.input.addEventListener('input', () => { clearTimeout(this.t); this.t = setTimeout(() => this.search(), 250); });      this.listen();
    }
    listen() {
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onDocKey);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onDocKey);
      clearTimeout(this.t);
      if (this.ctrl) this.ctrl.abort();
      unlock(this);
    }
    open(trigger) {
      if (!this.hidden) return;
      const t = trigger || document.activeElement;
      this.trigger = t && t !== document.body ? t : null;
      this.hidden = false;
      lock(this);
      $$('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => this.input.focus(), 10);
    }
    close() {
      if (this.hidden) return;
      clearTimeout(this.t);
      this.hidden = true;
      unlock(this);
      $$('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      const back = this.trigger && this.trigger.isConnected ? this.trigger : $('[data-search-open]');
      back && back.focus && back.focus({ preventScroll: true });
    }
    options() { return $$('[role="option"]', this.results); }
    setActive(i) {
      const opts = this.options();
      this.active = i;
      opts.forEach((o, n) => o.setAttribute('aria-selected', String(n === i)));
      if (i > -1 && opts[i]) {
        if (!opts[i].id) opts[i].id = `ps-opt-${i}`;
        this.input.setAttribute('aria-activedescendant', opts[i].id);
        opts[i].scrollIntoView({ block: 'nearest' });
      } else this.input.removeAttribute('aria-activedescendant');
    }
    onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); this.close(); return; }
      U.trapFocus(this, e);
      /* Arrow/Enter navigation belongs to the combobox only; Enter on "View all" etc. must act normally. */
      if (e.target !== this.input) return;
      const opts = this.options();
      if (!opts.length || !['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;
      if (e.key === 'Enter') { if (this.active > -1 && opts[this.active]) { e.preventDefault(); opts[this.active].click(); } return; }
      e.preventDefault();
      const n = opts.length;
      this.setActive(e.key === 'ArrowDown' ? (this.active + 1) % n : (this.active <= 0 ? n - 1 : this.active - 1));
    }
    async search() {
      const q = this.input.value.trim();
      this.setActive(-1);
      if (this.ctrl) this.ctrl.abort();
      if (!q) {
        this.results.innerHTML = '';
        if (this.defaults) this.defaults.hidden = false;
        this.input.setAttribute('aria-expanded', 'false');
        if (this.status) this.status.textContent = '';
        return;
      }
      const ctrl = 'AbortController' in window ? new AbortController() : null;
      this.ctrl = ctrl;
      this.setAttribute('aria-busy', 'true');
      try {
        const url = `${theme.routes.search || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const res = await fetch(url, ctrl ? { signal: ctrl.signal } : undefined);
        const text = await res.text();
        /* Ignore stale responses: a newer query or a cleared field wins. */
        if (this.ctrl !== ctrl || this.input.value.trim() !== q) return;
        const html = new DOMParser().parseFromString(text, 'text/html');
        const ps = html.querySelector('.ps');
        this.results.innerHTML = ps ? ps.outerHTML : '';
        if (this.defaults) this.defaults.hidden = !!ps;
        this.input.setAttribute('aria-expanded', ps && this.options().length ? 'true' : 'false');
        if (this.status) {
          const n = ps ? parseInt(ps.dataset.count, 10) || 0 : 0;
          const list = ps && $('.ps__products', ps);
          const prev = list && list.previousElementSibling;
          const label = prev && prev.classList.contains('eyebrow') ? prev.textContent.trim() : 'results'; /* localized section label */
          this.status.textContent = !ps ? '' : n ? `${n} ${label}` : (ps.textContent || '').replace(/\s+/g, ' ').trim();
        }
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        if (this.status) this.status.textContent = '';
      } finally {
        if (this.ctrl === ctrl) this.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  /* ---------- Email popup (delayed, never on first paint, remembers dismissal) ---------- */
  class EmailPopup extends HTMLElement {
    connectedCallback() {
      if (this._bound || !this.querySelector('template')) return;
      this._bound = true;
      const until = store.get('novy:popup-until', 0);
      if (Date.now() < until || store.get('novy:subscribed', false)) return;
      if (/customer_posted=true/.test(window.location.search)) { store.set('novy:subscribed', true); return; }
      const views = store.get('novy:pv', 0) + 1; store.set('novy:pv', views);
      const minViews = parseInt(this.dataset.pageviews, 10) || 2;
      const delay = (parseInt(this.dataset.delay, 10) || 12) * 1000;
      if (views >= minViews) { this.timer = setTimeout(() => this.show(), 1500); return; }
      this.timer = setTimeout(() => this.show(), delay);
      if (this.dataset.exit === 'true' && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
        this.exit = (e) => { if (e.clientY <= 0) this.show(); };
        document.addEventListener('mouseout', this.exit);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.exit && document.removeEventListener('mouseout', this.exit);
    }
    show() {
      if (this.shown || !this.isConnected) return;
      if (document.querySelector('.drawer.is-open, .search-overlay:not([hidden]), dialog[open]')) { this.timer = setTimeout(() => this.show(), 8000); return; }
      this.shown = true;
      clearTimeout(this.timer);
      this.exit && document.removeEventListener('mouseout', this.exit);
      const tpl = this.querySelector('template');
      if (!tpl) return;
      this.appendChild(tpl.content.cloneNode(true));
      this.hidden = false;
      this.prev = document.activeElement;
      const panel = $('.popup__panel', this);
      $('input[type="email"]', panel)?.focus({ preventScroll: true });
      this.addEventListener('click', (e) => { if (e.target.closest('[data-popup-close]')) this.dismiss(); });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.dismiss(); U.trapFocus(panel, e); });
      const form = $('form', panel);
      form && form.addEventListener('submit', (e) => this.submit(e, form));
      /* No code configured (the store doesn't use promo codes): drop the empty code box. */
      const copy = $('[data-copy-code]', panel);
      if (!this.dataset.code) { copy && copy.closest('.code-box')?.remove(); }
      else copy?.addEventListener('click', async (e) => {
        const b = e.currentTarget;
        try { await navigator.clipboard.writeText(this.dataset.code); b.textContent = theme.strings.copied || 'Copied'; } catch (err) { /* ignore */ }
      });
    }
    async submit(e, form) {
      e.preventDefault();
      const btn = $('[type="submit"]', form); btn && btn.classList.add('is-loading');
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        const ok = res.ok && (/customer_posted=true/.test(res.url) || !/errors/.test(res.url));
        if (ok) {
          store.set('novy:subscribed', true);
          const f = $('[data-popup-form]', this); if (f) f.hidden = true;
          const s = $('[data-popup-success]', this);
          if (s) { s.hidden = false; s.setAttribute('tabindex', '-1'); s.focus(); U.announce(s.textContent.replace(/\s+/g, ' ').trim()); }
        } else { HTMLFormElement.prototype.submit.call(form); }
      } catch (err) { HTMLFormElement.prototype.submit.call(form); } finally { btn && btn.classList.remove('is-loading'); }
    }
    dismiss() {
      const days = parseInt(this.dataset.days, 10) || 30;
      store.set('novy:popup-until', Date.now() + days * 864e5);
      this.hidden = true; this.innerHTML = '';
      this.prev && this.prev.focus && this.prev.focus();
    }
  }
  if (!customElements.get('email-popup')) customElements.define('email-popup', EmailPopup);

  /* ---------- Honest countdown: counts to a real fixed date, never resets ---------- */
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      /* Liquid's %z gives "-0400"; older Safari only parses "-04:00", so add the colon. */
      const raw = String(this.dataset.end || '').trim().replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      this.end = new Date(raw).getTime();
      if (Number.isNaN(this.end)) return;
      /* Only reload if it reached zero while being watched: an already-past date would reload forever. */
      this.wasRunning = this.end - Date.now() > 0;
      this.tick();
      if (this.wasRunning) this.t = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
    tick() {
      const diff = this.end - Date.now();
      const s = Math.max(0, Math.floor(diff / 1000));
      const set = (k, v) => { const el = this.querySelector(`[data-${k}]`); if (el) el.textContent = String(v).padStart(2, '0'); };
      set('d', Math.floor(s / 86400)); set('h', Math.floor((s % 86400) / 3600)); set('m', Math.floor((s % 3600) / 60)); set('s', s % 60);
      if (diff <= 0) {
        clearInterval(this.t); this.t = null;
        if (this.wasRunning) { this.wasRunning = false; setTimeout(() => window.location.reload(), 1500); }
      }
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  /* ---------- Recently viewed (render) ---------- */
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const list = store.get('novy:recent', []).filter((p) => p.handle !== this.dataset.exclude).slice(0, parseInt(this.dataset.limit, 10) || 4);
      if (!list.length) return;
      const ul = $('[data-rv-list]', this);
      const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      ul.innerHTML = list.map((p) => `
        <li class="grid__item"><article class="card">
          <a href="${esc(p.url)}" class="card__media" tabindex="-1" aria-hidden="true">${p.image ? `<img class="card__img" src="${esc(p.image)}" alt="" loading="lazy" width="400" height="500">` : '<div class="card__img placeholder-svg" aria-hidden="true"></div>'}</a>
          <div class="card__info"><h3 class="card__title"><a class="card__link" href="${esc(p.url)}">${esc(p.title)}</a></h3>
          <div class="price"><span class="price__current">${esc(p.price)}</span></div></div>
        </article></li>`).join('');
      this.hidden = false;
    }
  }
  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);

  /* ---------- UGC video: tap to play, one at a time, sound toggle ---------- */
  class UgcVideo extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this.video = $('video', this); if (!this.video) return;
      this._bound = true;
      this.play = $('[data-play]', this); this.sound = $('[data-sound]', this);
      this.video.muted = true; this.video.setAttribute('playsinline', '');
      this.play?.addEventListener('click', () => this.toggle());
      this.video.addEventListener('click', () => this.toggle());
      this.sound?.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        this.sound.setAttribute('aria-pressed', String(!this.video.muted));
      });
      this.video.addEventListener('ended', () => { this.play && (this.play.hidden = false); });
    }
    toggle() {
      if (this.video.paused) {
        $$('ugc-video video').forEach((v) => { if (v !== this.video) { v.pause(); v.closest('ugc-video')?.querySelector('[data-play]')?.removeAttribute('hidden'); } });
        const p = this.video.play();
        this.play && (this.play.hidden = true); this.sound && (this.sound.hidden = false);
        if (p && p.catch) p.catch(() => { this.play && (this.play.hidden = false); });
      } else { this.video.pause(); this.play && (this.play.hidden = false); }
    }
  }
  if (!customElements.get('ugc-video')) customElements.define('ugc-video', UgcVideo);

  /* ---------- Product recommendations (lazy) ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length || this._bound) return;
      this._bound = true;
      if (!this.dataset.url) { this.closest('.section')?.setAttribute('hidden', ''); return; }
      const load = async () => {
        try {
          const html = new DOMParser().parseFromString(await (await fetch(this.dataset.url)).text(), 'text/html');
          const fresh = html.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          else this.closest('.section')?.setAttribute('hidden', '');
        } catch (e) { this.closest('.section')?.setAttribute('hidden', ''); }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver(([en]) => { if (!en.isIntersecting) return; io.disconnect(); load(); }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
